module.exports = __webpack_public_path__ + "static/img/up1.cb82262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/up1.png
// module id = 8zWR
// module chunks = 1